import type { FC } from 'react';
import React from 'react';
import ContentLoader from 'react-content-loader';
import { Show } from '../../../components/atoms/Show';

interface RedcatPaymentCardFormSkeletonProps {
  readonly showStoreDetails?: boolean;
}

// Mirrors the layout Adyen's Card component renders into containerRef once mounted:
// a full-width card number field, then expiry date + CVC side by side, then an
// optional "save card" checkbox row. Shown while that container is still empty.
export const RedcatPaymentCardFormSkeleton: FC<RedcatPaymentCardFormSkeletonProps> = ({
  showStoreDetails = false,
}) => (
  <ContentLoader
    speed={2}
    width="100%"
    height="100%"
    viewBox={`0 0 560 ${showStoreDetails ? 284 : 224}`}
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    data-testid="redcat-payment-card-form-skeleton"
  >
    {/* "All fields are required unless marked otherwise." instruction line */}
    <rect x="0" y="0" rx="3" ry="3" width="280" height="12" />

    {/* Card number label + input */}
    <rect x="0" y="32" rx="3" ry="3" width="126" height="14" />
    <rect x="0" y="54" rx="4" ry="4" width="560" height="40" />

    {/* Brand icon list */}
    <rect x="0" y="104" rx="2" ry="2" width="24" height="16" />
    <rect x="32" y="104" rx="2" ry="2" width="24" height="16" />
    <rect x="64" y="104" rx="2" ry="2" width="24" height="16" />
    <rect x="96" y="104" rx="2" ry="2" width="24" height="16" />
    <rect x="128" y="104" rx="2" ry="2" width="24" height="16" />
    <rect x="160" y="104" rx="2" ry="2" width="24" height="16" />
    <rect x="192" y="104" rx="2" ry="2" width="24" height="16" />

    {/* Expiry date label + input */}
    <rect x="0" y="138" rx="3" ry="3" width="98" height="14" />
    <rect x="0" y="160" rx="4" ry="4" width="272" height="40" />

    {/* Security code label + input */}
    <rect x="288" y="138" rx="3" ry="3" width="98" height="14" />
    <rect x="288" y="160" rx="4" ry="4" width="272" height="40" />

    {/* Save card checkbox */}
    <Show when={showStoreDetails}>
      <rect x="0" y="216" rx="2" ry="2" width="16" height="16" />
      <rect x="24" y="219" rx="3" ry="3" width="224" height="10" />
    </Show>
  </ContentLoader>
);
